export default "__VITE_ASSET__D8w9tAiQ__"